
import React from 'react';

import { useTranslation } from 'react-i18next';

const Setting = (props) => {
    const { t } = useTranslation();

   
 
    return (
        <>
         
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">{t('support.support')}</h5>
                        <div className="card-body">
                            <div dangerouslySetInnerHTML={{ __html: t('support.message') }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Setting;